<template>
    <transition name="fade" v-if="enableTool">
        <control-schooldistance
            :data-panel="pageID"
            :moduleCode="moduleCode"
            :posBtnMap="mapButtons.schooldistance.position"
            :idxBtnMap="mapButtons.schooldistance.order"
            :showLabelBtnMap="mapButtons.schooldistance.showLabel"
            :collapsible="mapButtons.schooldistance.collapsible"
            :collapsed="initialCollapsedExpandCollapse"
            :showButtonOnActionMap="showButtonOnActionMap"
            processDescription="O percurso apresentado foi elaborado com recurso a um software de análise da rede rodoviária, que calcula a distância mais curta (em metros) entre o nº de polícia da morada de residência do aluno e o nº de polícia da morada da escola."
            processDistanceDescripton="O cálculo da distância foi efetuado considerando que o percurso é feito de carro, e considerou os sentidos de trânsito e as restrições de viragem."
            processTitleList="Detalhes do Percurso:"
            processError="Ocorreu um erro a calcular a rota."
            processEmpty="Não existe nenhuma rota transitável de carro, entre os pontos seleccionados."
        >
        </control-schooldistance>
    </transition>
</template>

<script>
    import ToolMixin from './mixins/ToolMixin';

    export default {
        mixins: [
            ToolMixin,
        ],
        components: {
            'control-schooldistance': () => import(/* webpackChunkName: "control-schooldistance" */ '@/components/maps/control/schoolDistanceControl'),
        },
        data() {
            return {
                pageID: 'schooldistance'
            }
        },
    }
</script>